type IArquivos = {
    arquivo: any;
    nome: string;
};

type ISubPasta = {
    titleSubPasta: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};

type IMaterial = {
    isPaste?: boolean;
    titlePaste?: string;
    arquivos: IArquivos[];
    subPastas?: ISubPasta[];
};
type TItem = {
    title: string;
    materiais: IMaterial[];
};

export const ListMateriaisAceleraPlanoAnual: TItem[] = [
    {
        title: 'Avaliação Formativa',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Orientacao_para_aplicacao_e_correçao_das_provas_ACELERA',
                        arquivo: 'ACELERA_Materiais_2026/AVALIACAO_FORMATIVA/Orientacao_para_aplicacao_e_correçao_das_provas_ACELERA.pdf',
                    },
                    {
                        nome: 'PROVA LIVRO_1 ACELERA',
                        arquivo: 'ACELERA_Materiais_2026/AVALIACAO_FORMATIVA/PROVA LIVRO_1 ACELERA.pdf',
                    },
                    {
                        nome: 'PROVA LIVRO_2 ACELERA',
                        arquivo: 'ACELERA_Materiais_2026/AVALIACAO_FORMATIVA/PROVA LIVRO_2 ACELERA.pdf',
                    },
                    {
                        nome: 'PROVA LIVRO_3 ACELERA',
                        arquivo: 'ACELERA_Materiais_2026/AVALIACAO_FORMATIVA/PROVA LIVRO_3 ACELERA.pdf',
                    },
                    {
                        nome: 'QUADRO DE HABILIDADES_ACELERA',
                        arquivo: 'ACELERA_Materiais_2026/AVALIACAO_FORMATIVA/QUADRO DE HABILIDADES_ACELERA.pdf',
                    },
                    {
                        nome: 'Quadro_habilidades_Avaliação_1_Acelera',
                        arquivo: 'ACELERA_Materiais_2026/AVALIACAO_FORMATIVA/Quadro_habilidades_Avaliação_1_Acelera.pdf',
                    },
                    {
                        nome: 'Quadro_habilidades_Avaliação_2_Acelera',
                        arquivo: 'ACELERA_Materiais_2026/AVALIACAO_FORMATIVA/Quadro_habilidades_Avaliação_2_Acelera.pdf',
                    },
                    {
                        nome: 'Quadro_habilidades_Avaliacao_3_Acelera',
                        arquivo: 'ACELERA_Materiais_2026/AVALIACAO_FORMATIVA/Quadro_habilidades_Avaliacao_3_Acelera.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Materiais Didáticos',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Letramento Científico',
                arquivos: [
                    {
                        nome: 'Guia Letramento Cientifico_Acelera Brasil',
                        arquivo:
                            'ACELERA_Materiais_2026/MATERIAIS DIDÁTICOS/LETRAMENTO CIENTÍFICO/Guia Letramento Cientifico_Acelera Brasil.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Livro Aluno',
                arquivos: [
                    {
                        nome: 'AB_Livro1_Aluno',
                        arquivo: 'ACELERA_Materiais_2026/MATERIAIS DIDÁTICOS/LIVRO ALUNO/AB_Livro1_Aluno.pdf',
                    },
                    {
                        nome: 'AB_Livro2_Aluno',
                        arquivo: 'ACELERA_Materiais_2026/MATERIAIS DIDÁTICOS/LIVRO ALUNO/AB_Livro2_Aluno.pdf',
                    },
                    {
                        nome: 'AB_Livro3_Aluno',
                        arquivo: 'ACELERA_Materiais_2026/MATERIAIS DIDÁTICOS/LIVRO ALUNO/AB_Livro3_Aluno.pdf',
                    },
                    {
                        nome: 'AB_Livro4_Aluno',
                        arquivo: 'ACELERA_Materiais_2026/MATERIAIS DIDÁTICOS/LIVRO ALUNO/AB_Livro4_Aluno.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Livro Professor',
                arquivos: [
                    {
                        nome: 'AB_LivroProfessor',
                        arquivo: 'ACELERA_Materiais_2026/MATERIAIS DIDÁTICOS/LIVRO PROFESSOR/AB_LivroProfessor.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Subsídios',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Acelera_Subsídios para o início do programa',
                        arquivo: 'ACELERA_Materiais_2026/SUBSÍDIOS/Acelera_Subsídios para o início do programa.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Testes Diagnósticos',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Orientacao Teste Diagnostico_ SL e AB 2023_alfabetização',
                        arquivo: 'ACELERA_Materiais_2026/TESTES DIAGNÓSTICOS/Orientacao Teste Diagnostico_ SL e AB 2023_alfabetização.pdf',
                    },
                    // {
                    //     nome: 'Orientacao Teste Diagnostico_ SL e AB 2023_matemática',
                    //     arquivo: 'ACELERA_Materiais_2026/TESTES DIAGNÓSTICOS/Orientacao Teste Diagnostico_ SL e AB 2023_matemática.pdf',
                    // },
                    {
                        nome: 'Teste Diagnostico de alfabetizacao _SL e AB',
                        arquivo: 'ACELERA_Materiais_2026/TESTES DIAGNÓSTICOS/Teste Diagnostico de alfabetizacao _SL e AB.pdf',
                    },
                    // {
                    //     nome: 'Teste Diagnostico de matemática _SL e AB',
                    //     arquivo: 'ACELERA_Materiais_2026/TESTES DIAGNÓSTICOS/Teste Diagnostico de matemática _SL e AB.pdf',
                    // },
                ],
            },
        ],
    },
    {
        title: 'Visão Geral e Sistemática de Acompanhamento',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'SeLiga_Acelera_SISTEMATICA_DE_ACOMPANHAMENTO',
                        arquivo:
                            'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/SeLiga_Acelera_SISTEMATICA_DE_ACOMPANHAMENTO.pdf',
                    },
                    {
                        nome: 'Visão Geral_Acelera',
                        arquivo: 'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Visão Geral_Acelera.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Cartazes',
                        arquivos: [
                            {
                                nome: 'AB_SL_cartaz_ACOMPANHAMENTO LIVROS LIDOS',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Cartazes/AB_SL_cartaz_ACOMPANHAMENTO LIVROS LIDOS.pdf',
                            },
                            {
                                nome: 'AB_SL_cartaz_ACOMPANHAMENTO MENSAL I A',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Cartazes/AB_SL_cartaz_ACOMPANHAMENTO MENSAL I A.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Relatórios Qualitativos',
                        arquivos: [
                            {
                                nome: 'SeLiga_Acelera_Relatorio_A',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Relatórios Qualitativos/SeLiga_Acelera_Relatorio_A.pdf',
                            },
                            {
                                nome: 'SeLiga_Acelera_Relatorio_B',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Relatórios Qualitativos/SeLiga_Acelera_Relatorio_B.pdf',
                            },
                            {
                                nome: 'SeLiga_Acelera_Relatorio_C',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Relatórios Qualitativos/SeLiga_Acelera_Relatorio_C.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Tabelas',
                        arquivos: [
                            {
                                nome: 'AB_SL_tabela_PERFIL TURMA I',
                                arquivo: 'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Tabelas/AB_SL_tabela_PERFIL TURMA I.pdf',
                            },
                            {
                                nome: 'AB_SL_tabela_PERFIL TURMA II',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Tabelas/AB_SL_tabela_PERFIL TURMA II.pdf',
                            },
                            {
                                nome: 'AB_SL_tabela_RESULTADO FINAL I',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Tabelas/AB_SL_tabela_RESULTADO FINAL I.pdf',
                            },
                            {
                                nome: 'AB_SL_tabela_RESULTADO FINAL II',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Tabelas/AB_SL_tabela_RESULTADO FINAL II.pdf',
                            },
                            {
                                nome: 'AB_tabela_ACOMPANHAMENTO MENSAL I C',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Tabelas/AB_tabela_ACOMPANHAMENTO MENSAL I C.pdf',
                            },
                            {
                                nome: 'AB_tabela_ACOMPANHAMENTO MENSAL II B',
                                arquivo:
                                    'ACELERA_Materiais_2026/VISAO_GERAL_SISTEMATICA_ACOMPANHAMENTO/Tabelas/AB_tabela_ACOMPANHAMENTO MENSAL II B.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
